import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import Bitacoras from "../../../views/BitacorasPorUnidad/Bitacoras/Bitacoras";

const BitacorasByUnit = () => {
    return (
        <Routes>
            <Route exact path="/bitacorasporunidad/bitacoras"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <Bitacoras></Bitacoras>
                       </Suspense>
                   }>
            </Route>
        </Routes>
    )

}

export default BitacorasByUnit
